export function getSession(updating = false) {
    var sessionKey = localStorage.getItem("sessionKey");
    var sessionData = localStorage.getItem("sessionData");

    if (!sessionKey) {
        return {}
    }

    return {
        sessionKey,
        data: JSON.parse(sessionData)
    }
}

export function putSession(session) {
    localStorage.setItem("sessionKey", session.sessionKey);
    localStorage.setItem("sessionData", JSON.stringify(session.data));
}

export function isAuthed() {
    return !!localStorage.getItem("sessionKey");
}